export default __webpack_public_path__ + "static/media/infoPasta.2efbf08c.svg";